export default __webpack_public_path__ + "static/media/storyImage.b2b01787.svg";